export default __webpack_public_path__ + "static/media/Champagne Christmas wreth.0273d519.jpg";